import React from 'react';
import { Empty } from 'seedly-component-library';
import ButtonNew from 'seedly-component-library/button-new';
import Spinner from 'seedly-component-library/spinner-new';
import { useHasMoreFeed, useFeedApiStatus } from 'entity/feed/feedHooks';
import ErrorCard from 'components/post/ErrorCard';

import useGetFeedListData from './hooks/useGetFeedListData';

const FeedList = props => {
  const { handleLoadMoreFeed } = props;

  const {
    isFetching,
    isFetchingMoreFeed,
    isFetchFeedsError,
  } = useFeedApiStatus();

  const hasMoreFeed = useHasMoreFeed();
  const feedList = useGetFeedListData();

  if (isFetchFeedsError) {
    return <ErrorCard />;
  }

  if (isFetching) {
    return (
      <div className="flex flex-col w-full items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="list">
        {feedList.length > 0 ? feedList : <Empty title="No Posts Found." />}
      </div>
      {hasMoreFeed && !isFetching && (
        <div className="flex item-center justify-center mt-6">
          <ButtonNew
            variant="ghost"
            onClick={handleLoadMoreFeed}
            isLoading={isFetchingMoreFeed}
          >
            Load more discussions
          </ButtonNew>
        </div>
      )}
    </div>
  );
};

export default FeedList;
